import React, { Component } from "react";
import * as THREE from "three";
import { OrbitControls } from "./OrbitControls.js";
import "./index.css";

export default class Node extends Component {
  componentDidMount() {
    /// ---------------------------
    //  INIT
    /// ---------------------------
    let widthPersonal = 0;
    let heightPersonal = 0;
    let positionX = 0;
    let positionY = 0;
    let divParticle = this.mount;

    function calcSize() {
      if (window.matchMedia("(max-width: 850px)").matches) {
        widthPersonal = divParticle.clientWidth;
        heightPersonal = divParticle.clientHeight;
        positionX = 0;
        positionY = -(heightPersonal * 0.5) + 105;
      } else {
        widthPersonal = divParticle.clientWidth;
        heightPersonal = divParticle.clientHeight;
        positionX = divParticle.clientWidth / 3.5;
        positionY = 0;
      }
    }

    calcSize();

    this.width = widthPersonal;
    this.height = heightPersonal;
    this.centerX = this.width / 2;
    this.centerY = this.height / 2;
    this.geometrySize = 200;
    this.blockTime = 5000;
    this.TransactionsPerSecond = 2000;
    this.activeStep = 1;
    this.maxNodes = 15;
    this.minNodesDistance = 200;

    this.draw = function (x, y, z, name, color) {
      let randNumber = Math.random();
      var geometry = new THREE.Geometry();
      geometry.name = name;

      for (let i = 0; i < 4000; i++) {
        var vertex = new THREE.Vector3();
        vertex.x = randNumber * 4000 - 100;
        randNumber = Math.random();
        vertex.y = randNumber * 4000 - 100;
        randNumber = Math.random();
        vertex.z = randNumber * 4000 - 100;
        geometry.vertices.push(vertex);
      }

      var material = new THREE.PointsMaterial({
        size: 5,
        color,
        opacity: 0.9,
        transparent: true,
      });

      var particles = new THREE.Points(geometry, material);
      particles.rotation.x = randNumber * 9;
      particles.rotation.y = randNumber * 9;
      particles.rotation.z = randNumber * 9;
      particles.name = "PARTICULAS";
      this.scene.add(particles);
    };

    this.initRenderer = function () {
      this.renderer = new THREE.WebGLRenderer({ alpha: true });
      this.renderer.setSize(widthPersonal, heightPersonal);
      this.renderer.setClearColor(0x000000, 0);
      this.renderer.sortObjects = false;

      this.scene = new THREE.Scene();
      this.scene.fog = new THREE.Fog(0x000000, 1000, 4000);

      this.camera = new THREE.PerspectiveCamera(
        45,
        this.width / this.height,
        1,
        10000
      );

      if (window.matchMedia("(max-width: 1000px)").matches) {
        this.camera.position.set(400, 0, 1450);
      } else {
        this.camera.position.set(400, 0, 1250);
      }

      this.scene.add(this.camera);

      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.enableZoom = false;
      this.controls.dampingFactor = 0.07;
      this.controls.rotateSpeed = 0.04;
      this.controls.autoRotate = false;

      var ambientLight = new THREE.AmbientLight(0x999999, 1);
      this.scene.add(ambientLight);

      window.addEventListener("resize", onWindowResize);
      this.mount.appendChild(this.renderer.domElement);
    };

    /// ---------------------------
    //  APP
    /// ---------------------------

    this.launchApp = function () {
      this.node = this.createNodeGroup();
      this.node.position.x = positionX;
      this.node.position.y = positionY;

      this.scene.add(this.node);
    };

    /// ---------------------------
    //  node UTILS
    /// ---------------------------

    this.createNodeGroup = function () {
      var nodeGroup = new THREE.Object3D();
      this.nodeRotationGroup = new THREE.Object3D();
      var nodeSegmentsGroup = new THREE.Object3D();

      var node = this.createnode();

      this.createNodeLight(this.nodeRotationGroup);
      this.createNodes(this.nodeRotationGroup);
      this.nodeRotationGroup.add(node);
      this.createSegments(nodeSegmentsGroup);
      nodeGroup.add(this.nodeRotationGroup);
      nodeGroup.add(nodeSegmentsGroup);

      return nodeGroup;
    };

    this.createnode = function () {
      var geometry = new THREE.SphereGeometry(this.geometrySize / 1.5, 15, 15);
      // materials are rendered in two parts to prevent transparency bug
      var materialFront = new THREE.MeshPhongMaterial({
        color: 0x11111f,
        side: THREE.BackSide,
        transparent: true,
        opacity: 0.4,
      });
      var nodeGroup = new THREE.Object3D();
      var node = new THREE.Mesh(geometry, materialFront);
      nodeGroup.add(node);
      return nodeGroup;
    };

    this.createNodes = function (nodeRotationGroup) {
      this.nodes = [];
      var colors = ["6e40c9", "9661fd", "c7bddb", "544474"];

      for (var i = 0; i < this.maxNodes; i++) {
        var color = parseInt(colors[i % colors.length], 16);
        var node = new THREE.Object3D();
        var nodeSphere = new THREE.Mesh(
          new THREE.SphereGeometry(6, 16, 8),
          new THREE.MeshBasicMaterial({
            color: color,
            transparent: true,
            opacity: 0.9,
          })
        );
        nodeSphere.position.x = -350;
        node.name = "nodeNodes";
        node.add(nodeSphere);
        node.rotation.x = Math.floor(Math.random() * Math.floor(100));
        node.rotation.z = Math.floor(Math.random() * Math.floor(100));
        node.rotation.y = Math.floor(Math.random() * Math.floor(100));
        nodeRotationGroup.add(node);
        this.nodes.push(node);
      }
    };

    this.createSegments = function (nodeSegmentsGroup) {
      var segments = this.maxNodes * this.maxNodes;

      this.positions = new Float32Array(segments * 3);
      this.colors = new Float32Array(segments * 3);
      this.particlePositions = new Float32Array(this.maxNodes * 3);

      var geometry = new THREE.BufferGeometry();

      geometry.setAttribute(
        "position",
        new THREE.BufferAttribute(this.positions, 3).setUsage(true)
      );
      geometry.setAttribute(
        "color",
        new THREE.BufferAttribute(this.colors, 3).setUsage(true)
      );
      geometry.computeBoundingSphere();
      geometry.setDrawRange(0, 0);

      var material = new THREE.LineBasicMaterial({
        vertexColors: THREE.VertexColors,
        blending: THREE.AdditiveBlending,
        transparent: true,
      });

      this.linesMesh = new THREE.LineSegments(geometry, material);
      nodeSegmentsGroup.add(this.linesMesh);
    };
    this.setNodesPosition = function () {
      this.linesMesh.geometry.setDrawRange(0, this.numConnected * 2);
      this.linesMesh.geometry.attributes.position.needsUpdate = true;
      this.linesMesh.geometry.attributes.color.needsUpdate = true;
    };
    this.compareNodesPosition = function (i) {
      for (var j = i + 1; j < this.maxNodes; j++) {
        var dx = this.particlePositions[i * 3] - this.particlePositions[j * 3];
        var dy =
          this.particlePositions[i * 3 + 1] - this.particlePositions[j * 3 + 1];
        var dz =
          this.particlePositions[i * 3 + 2] - this.particlePositions[j * 3 + 2];
        var dist = Math.sqrt(dx * dx + dy * dy + dz * dz);

        if (dist < this.minNodesDistance) {
          var alpha = 1.0 - dist / this.minNodesDistance;

          this.positions[this.vertexPos++] = this.particlePositions[i * 3];
          this.positions[this.vertexPos++] = this.particlePositions[i * 3 + 1];
          this.positions[this.vertexPos++] = this.particlePositions[i * 3 + 2];

          this.colors[this.colorPos++] = alpha;
          this.colors[this.colorPos++] = alpha;
          this.colors[this.colorPos++] = alpha;

          this.numConnected++;
        }
      }
    };

    this.createNodeLight = function (nodeRotationGroup) {
      var color = parseInt("6e40c9", 16);
      var light = new THREE.PointLight(color, 10, 500, 1);
      light.add(
        new THREE.Mesh(
          new THREE.SphereGeometry(55, 16, 8),
          new THREE.MeshBasicMaterial({
            color: 0x6e40c9,
            transparent: true,
            opacity: 1,
          })
        )
      );
      light.castShadow = false;

      light.name = "nodeLight";
      nodeRotationGroup.add(light);
    };

    /// ---------------------------
    //  UTILS
    /// ---------------------------

    const onWindowResize = (self) => {
      calcSize(); //ACTIVAR SOLO EN TESTING
      this.width = widthPersonal;
      this.centerX = this.width / 3;

      this.camera.aspect = this.width / this.height;
      this.camera.updateProjectionMatrix();

      this.renderer.setSize(this.width, this.height);
    };

    const clock = new THREE.Clock();
    this.animate = function (now) {
      const elapsedTime = clock.getElapsedTime();

      this.controls.update();
      requestAnimationFrame(this.animate.bind(this));
      var particles = this.scene.getObjectByName("PARTICULAS");

      if (particles) {
        particles.rotation.y += 0.005;
      }
      if (this.nodeRotationGroup && this.rotationX && this.rotationY) {
        this.nodeRotationGroup.rotation.y +=
          (this.rotationX - this.nodeRotationGroup.rotation.y) * 0.05;
        this.nodeRotationGroup.rotation.x +=
          (this.rotationY - this.nodeRotationGroup.rotation.x) * 0.05;
      }

      this.nodeRotationGroup.position.y =
        this.nodeRotationGroup.position.y - Math.sin(elapsedTime) / 5;

      if (this.nodes) {
        this.vertexPos = 0;
        this.colorPos = 0;
        this.numConnected = 0;
        this.setNodesPosition();

        this.nodes[0].rotation.y = now * 0.00052;
        this.nodes[1].rotation.y = now * -0.00053;
        this.nodes[2].rotation.y = now * 0.00055;
        this.nodes[3].rotation.y = now * -0.00057;
        this.nodes[4].rotation.y = now * 0.000511;
        this.nodes[5].rotation.y = now * -0.000513;
        this.nodes[6].rotation.y = now * 0.000517;
        this.nodes[7].rotation.x = now * -0.000519;
        this.nodes[8].rotation.x = now * 0.000523;
        this.nodes[9].rotation.x = now * -0.000529;
        this.nodes[10].rotation.x = now * 0.000531;
        this.nodes[11].rotation.x = now * -0.000537;
        this.nodes[12].rotation.x = now * 0.000541;
        this.nodes[13].rotation.x = now * -0.000543;
        this.nodes[14].rotation.x = now * 0.000547;
      }

      this.renderer.render(this.scene, this.camera);
    };

    this.findMouseCoords = function (event) {
      if (event) {
        //FireFox
        this.mouseX = event.pageX - document.body.scrollLeft;
        this.mouseY = event.pageY - document.body.scrollTop;
      } else {
        //IE
        this.mouseX = window.event.x + 2;
        this.mouseY = window.event.y + 2;
      }

      var diffX = this.mouseX - this.centerX;
      var diffY = this.mouseY - this.centerY;
      var percentX = diffX / this.centerX;
      var percentY = diffY / this.centerY;

      this.rotationX = percentX / 2;
      this.rotationY = percentY / 2;
    };
    this.findMouseCoords = this.findMouseCoords.bind(this);

    this.initMouseEvents = function () {
      this.mount.addEventListener("mousemove", this.findMouseCoords);
    };
    this.stopMouseEvents = function () {
      this.mount.removeEventListener("mousemove", this.findMouseCoords);
    };

    this.initApp = function () {
      this.initRenderer();
      this.launchApp();
      this.initMouseEvents();
      this.animate();
      this.draw(-200, 20, 20, "blue", 0x6e40c9);

      // prevent animation bug when tab is inactive
      //   TweenLite.lagSmoothing(0);
    };

    /// ---------------------------
    //  START
    /// ---------------------------
    this.initApp();
  }

  render() {
    return (
      <div
        id="canvaParticle"
        ref={(mount) => {
          this.mount = mount;
        }}
      />
    );
  }
}
